import { Injectable } from "@angular/core";
import { Email } from "./recovery-bulk-upload/regex";
import { SharedService } from "src/app/components/shared/shared.service";

@Injectable({
  providedIn: 'root'
})
// @Injectable()

export class DebtRecoveryService {
    public modalTypes = {
        resendLinkModal: 'resendLinkModal',
        sendReceiptLinkModal: 'sendReceiptLinkModal',
        refundPaymentModal: 'refundPaymentModal',
		detailsModal: 'detailsModal',
		PaymentSettingsModal: 'PaymentSettingsModal',
		ResendPlanModal: 'ResendPlanModal',
		editExpiryDateModal: 'editExpiryDateModal',
		addAlternateContact:'addAlternateContact',
		addAlternateEmail:'addAlternateEmail',
		addNoticeContactInfo:'addNoticeContactInfo',
		viewFullSSN:'viewFullSSN',
		addEditSSN:'addEditSSN',
		addEditDOB:'addEditDOB',
		addSocialLink:'addSocialLink',
		addAddress:'addAddress',
		sendProposal:'sendProposal',
		DisputeDebt:'DisputeDebt',
		addDocument:'addDocument',
		refundPaymentInfoModal:'refundPaymentInfoModal',
		addSettleAmount:"addSettleAmount",
		addTLODocument: "addTLODocument",
		addNotesModal:"addNotesModal",
		addStatusModal:"addStatusModal",
		m2rReportModal:"m2rReportModal",
		demandLetterDate: "demandLetterDate",
		stopCollectionModal: "stopCollectionModal",
		stopTLOModal: "stopTLOModal",
		changeDisputeStatusModal:"changeDisputeStatusModal",
		updateDebInfo: "updateDebInfo",
		customPlanModal: "customPlanModal",
		communicationModal: "communicationModal",
		openScript: "openScript",
		outreachModal : "outreachModal",
		consentNotVerifiedModal : "consentNotVerifiedModal",
		generateFeePaymentLink: "generateFeePaymentLink",
		sharePaymentLink: "sharePaymentLink",
    }

	public qr_from = {
		recuvery: 0,
		denefits: 1,
		lendee: 2,
		credee: 3
	}

	constructor(private _shared: SharedService) {}

    getCalculatedTransactionFee(contract: any, comparable_value: any) {
		if (!contract) {
			contract = {}
		}
		contract = this.setTransactionFee(contract);
		comparable_value = parseFloat(comparable_value);
		let transaction_fee = 0;
		if (comparable_value === 0) {
			return 0;
		} else if ((comparable_value < contract.threshold_amount) || (contract.threshold_amount === undefined && contract.recurring_extra_amount !== undefined)) {
			if (contract.recurring_extra_percent) {
				transaction_fee += (comparable_value * contract.recurring_extra_percent) / 100;
			}
			if (contract.recurring_extra_amount) {
				transaction_fee += contract.recurring_extra_amount;
			}
		} else {
			if (contract.threshold_recurring_extra_percent) {
				transaction_fee += (comparable_value * contract.threshold_recurring_extra_percent) / 100;
			}
			if (contract.threshold_recurring_extra_amount) {
				transaction_fee += contract.threshold_recurring_extra_amount;
			}
		}
		return transaction_fee;
	}

    GetTransactionFee(contract: any, comparable_value: any) {
		comparable_value = parseFloat(comparable_value);
		contract = this.setTransactionFee(contract);		
		let text = '';
		if (comparable_value < contract.threshold_amount) {
		  if (contract.recurring_extra_percent) {
			text += `${parseFloat(contract.recurring_extra_percent).toFixed(2)}%`
		  }
		  if (contract.recurring_extra_amount && contract.recurring_extra_percent) {
			text += ' + ';
		  }
		  if (contract.recurring_extra_amount) {
			text += `${this._shared.getCurrencySymbol()}${parseFloat(contract.recurring_extra_amount).toFixed(2)}`
		  }
		} else {
		  if (contract.threshold_recurring_extra_percent) {
			text += `${parseFloat(contract.threshold_recurring_extra_percent).toFixed(2)}%`
		  }
		  if (contract.threshold_recurring_extra_amount && contract.threshold_recurring_extra_percent) {
			text += ' + ';
		  }
		  if (contract.threshold_recurring_extra_amount) {
			text += `${this._shared.getCurrencySymbol()}${parseFloat(contract.threshold_recurring_extra_amount).toFixed(2)}`
		  }
		}
		return text;
	  }

	setTransactionFee(contract: any) {
		if (contract) {
			contract.recurring_extra_amount = contract.recurring_extra_amount;
			contract.recurring_extra_percent = contract.recurring_extra_percent;
			contract.threshold_amount = contract.threshold_amount;
			contract.threshold_recurring_extra_amount = contract.threshold_recurring_extra_amount;
			contract.threshold_recurring_extra_percent = contract.threshold_recurring_extra_percent;
		} else {
			contract.recurring_extra_amount = 3;
			contract.recurring_extra_percent = 0;
			contract.threshold_amount = 100;
			contract.threshold_recurring_extra_amount = 0;
			contract.threshold_recurring_extra_percent = 3;
		}
		return contract;
	}
}